import { validatePerm } from '@/libs/validatePermission'
import { BACKOFFICE_USER_PERMISSION } from '@/constant/BACKOFFICE_PERMISSION'
import HealthClaimDetailPage from '@/components/feature/HealthClaimDetailPage/HealthClaimDetailPage'
import { HealthClaimModeEnum } from '@/constant/E_CLAIM'
import UnauthorizedPage from '@/pages/Unauthorized'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import healthClaimFormAtom from '@/recoil/healthClaimForm'
import userAtom from '@/recoil/user'
import { useEffect } from 'react'

const HealthClaimDetail = ({ mode }: { mode: HealthClaimModeEnum }) => {
  const user = useRecoilValue(userAtom)
  const setHealthClaim = useSetRecoilState(healthClaimFormAtom)

  useEffect(() => {
    setHealthClaim((prev) => ({ ...prev, mode }))
  }, [mode, setHealthClaim])

  return (
    <>
      {validatePerm([BACKOFFICE_USER_PERMISSION.CLM010104], user.permissions) ? (
        <HealthClaimDetailPage />
      ) : (
        <UnauthorizedPage />
      )}
    </>
  )
}

export default HealthClaimDetail
